import { COMMON_APIS, LOADED_FROM_CONFIG_ENVS } from './environment.consts';
import { IEnvironment } from './environment.type';

// При добавлении переменных окружения необходимо также добавлять их аргументами в Dockerfile
export const environment: IEnvironment = {
  production: true,
  configFile: '/assets/config/config.prod.json',
  api: {
    ...COMMON_APIS,
  },
  ...LOADED_FROM_CONFIG_ENVS, // Проставляются из /assets/config/config.prod.json
};
